import moment from "moment";

export default function formatTime(datetime) {
  const m = moment(datetime);
  return m.isValid() ? m.format("HH:mm") : "";
}
